import { useMemo } from 'react';
import { ENTITY_TYPE_RELATIONSHIP_SERVICE_METADATA } from '../consts';

const useTargetEntityDomainsToType = targetEntityTypes => {
  const joinedTargetEntityTypes = targetEntityTypes
    ? targetEntityTypes.join(',')
    : targetEntityTypes;
  return useMemo(() => {
    return targetEntityTypes
      ? targetEntityTypes.reduce((result, entityType) => {
        const { type, domain } = ENTITY_TYPE_RELATIONSHIP_SERVICE_METADATA[entityType];
        if (!result[domain]) {
          result[domain] = {};
        }
        result[domain][type] = entityType;
        return result;
      }, {})
      : {};
    // Disable as array check is done by reference. We want to change the value only if the array content changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [joinedTargetEntityTypes]);
};

export default useTargetEntityDomainsToType;
